import { render } from "./form-dataset-protocols.vue?vue&type=template&id=452a844c"
import script from "./form-dataset-protocols.vue?vue&type=script&lang=js"
export * from "./form-dataset-protocols.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__